import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import Checkbox from '@atlaskit/checkbox';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Text, xcss } from '@atlaskit/primitives';
import { sendUIEvent } from '../../../../../common/utils/analytics-client';
import { PreferenceCategory } from '../../../../../types';
var tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';

// Styles
var categoryBoxStyles = xcss({
  paddingBlockStart: 'space.200'
});
var categoryDescriptionStyles = xcss({
  paddingInlineStart: 'space.300',
  marginInlineStart: 'space.050'
});

// We don't bother tracking unknown checkbox toggles
var categoryToEventSubjectMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PreferenceCategory.Analytics, 'performanceConsent'), PreferenceCategory.Functional, 'functionalConsent'), PreferenceCategory.Marketing, 'targetingConsent'), PreferenceCategory.Unknown, null);
export var CookieCategorySection = function CookieCategorySection(_ref) {
  var category = _ref.category,
    titleElement = _ref.titleElement,
    titleString = _ref.titleString,
    descriptionElement = _ref.descriptionElement,
    isChecked = _ref.isChecked,
    setPreferencesData = _ref.setPreferencesData;
  var onCheckboxChange = useCallback(function () {
    // Don't alter cookies that are strictly necessary
    if (category === PreferenceCategory.StrictlyNecessary) {
      return;
    }
    setPreferencesData(function (prevPrefsData) {
      var isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
      var actionSubjectId = categoryToEventSubjectMap[category];
      if (actionSubjectId) {
        sendUIEvent({
          actionSubjectId: actionSubjectId,
          action: 'clicked',
          actionSubject: 'checkbox',
          source: 'cookieConsentModal',
          attributes: {
            isSelected: isSelected
          }
        });
      }
      return _objectSpread(_objectSpread({}, prevPrefsData), {}, {
        prefs: _objectSpread(_objectSpread({}, prevPrefsData.prefs), {}, _defineProperty({}, category, isSelected))
      });
    });
  }, [category, setPreferencesData]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: categoryBoxStyles
  }, /*#__PURE__*/React.createElement(Checkbox
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
  , {
    className: "".concat(tmpTrelloClassNameOverride),
    isChecked: isChecked,
    value: isChecked.toString(),
    onChange: onCheckboxChange,
    label: titleElement,
    name: "".concat(titleString)
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: categoryDescriptionStyles
  }, /*#__PURE__*/React.createElement(Text, {
    size: "UNSAFE_small",
    color: "color.text.subtle"
  }, descriptionElement)));
};